
import './App.css';
import { Provider } from 'react-redux';
import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom'
import { createStore } from 'redux';
import { reducer } from './Store/reducer'
import Loaders from './Components/Loaders/Loaders';
import Root from './Root/Root';
import "./i18n";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const store = createStore(reducer)
const queryClient = new QueryClient({defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,          // 5 minutes
      cacheTime: 60 * 60 * 1000,         // 10 minutes
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: 1,                          // Optional: retry failed queries once
    },
  }})

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Loaders />}>
        <Router>
          <div className="min-h-screen font flex flex-col relative" style={{ fontFamily: "Graphik, Helvetica, Arial, sans-serif" }}>
            <Root />
          </div>
        </Router>
      </Suspense>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
